import React from 'react';

import { Box, ZStack } from '@rbilabs/universal-components';
import { Platform, StyleSheet } from 'react-native';

import Picture from 'components/picture';
import { Typography, TypographyProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { primitive } from 'styles/constants';

import { headerWidgetTheme } from './theme';

/** Pre-migration Header `_web` sizes; native used headerOne (24px / `2xl`). */
const nativeHeroHeadingStyle = {
  pt: '$5',
  pb: '$2',
  fontSize: '2xl',
  lineHeight: 29,
} as const;

const getHeroHeadingStyle = (isDesktop: boolean) => {
  if (Platform.OS !== 'web') {
    return nativeHeroHeadingStyle;
  }
  return isDesktop
    ? ({ pt: '$4', pb: '$3', fontSize: '8xl', lineHeight: '2xs' } as const)
    : ({ pt: '$4', pb: '$3', fontSize: '5xl', lineHeight: '2xs' } as const);
};

export const StyledHeroHeading = (props: TypographyProps) => {
  const isDesktop = useIsDesktopBreakpoint();
  // Platform split is required: applying web tokens via isDesktop alone oversized native.
  const { pt, pb, fontSize, lineHeight } = getHeroHeadingStyle(isDesktop);

  return (
    <Typography
      variant="headerOne"
      pt={pt}
      pb={pb}
      px="$6"
      textAlign="center"
      color={primitive.$mayoEggWhite}
      fontSize={fontSize}
      lineHeight={lineHeight}
      {...props}
    />
  );
};

export const HeadingContainer = Box.withConfig({
  flexDirection: headerWidgetTheme.headerFlexDirection as any,
});

export const Heading = (props: TypographyProps) => (
  <Typography
    variant="headerOne"
    textAlign="center"
    m="$0"
    p="$0"
    fontSize="5xl"
    lineHeight="sm"
    color={headerWidgetTheme.textColor}
    style={styles.heading}
    {...props}
  />
);

export const Tagline = (props: TypographyProps) => (
  <Typography
    variant="headerTwo"
    textAlign="center"
    m="$0"
    p="$0"
    fontSize="3xl"
    lineHeight="xl"
    color={headerWidgetTheme.textColor}
    style={{ fontWeight: '400', position: 'relative' }}
    {...props}
  />
);

export const Container = ZStack.withConfig({
  height: '440px',
});

export const Top = Box.withConfig({
  background: headerWidgetTheme.background,
  width: 'full',
  paddingTop: '$8',
  paddingBottom: '$32',
});

export const Bottom = Box.withConfig({
  width: 'full',
  marginTop: '$48',
});

export const ImageContainer = Box.withConfig({
  alignItems: 'center',
});

export const Image = Picture.withConfig({
  borderRadius: 'md',
  width: '90%',
});

const styles = StyleSheet.create({
  heading: {
    letterSpacing: -2,
    fontWeight: '900',
    marginTop: -6,
    marginBottom: -6,
  },
});
